import script from "./StakingCryptoChoiceList.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingCryptoChoiceList.vue?vue&type=script&setup=true&lang=ts"

import "./StakingCryptoChoiceList.vue?vue&type=style&index=0&id=fbce60c8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbce60c8"]])

export default __exports__